import {Observable, of} from 'rxjs';
import {Injector} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {delay, map} from 'rxjs/operators';

let injector: Injector;
const ENABLED = true;
const FIXTURES_BASE_PATH = 'assets/mocker';
const DELAY_TIME_MS = 300;


interface jsonFile {
  kind: 'jsonFile',
  fileName: string
  overrides?: (e: any) => any
}

interface runtimeFaker {
  kind: 'runtimeFaker',
  filePath: string //relative to models folder,
  overrides?: any,
  skipCache?: boolean
}

interface customObject {
  kind: 'customObject',
  payload: any
}

interface httpSuccess204 {
  kind: 'httpSuccess204'
}

interface httpAccepted202 {
  kind: 'httpAccepted202';
}

interface httpOk200 {
  kind: 'httpOk200';
}

interface httpLocked423 {
  kind: 'httpLocked423'
}

interface httpBadGateway502 {
  kind: 'httpBadGateway502';
}

interface httpBadRequest400 {
  kind: 'httpBadRequest400';
}

interface file {
  kind: 'file';
  fileType: 'png' | 'jpg' | 'pdf';
}

export type responseType =
  jsonFile |
  runtimeFaker |
  customObject |
  file |
  httpAccepted202 |
  httpSuccess204 |
  httpLocked423 |
  httpBadRequest400 |
  httpOk200 |
  httpBadGateway502;

export interface MockConfig {
  skip?: boolean,
  response: responseType
}

export const Mock = (mockConfig: MockConfig): MethodDecorator => {
  let httpClient: HttpClient;
  const mockDecoratorEnabled = ENABLED;
  return (() => {
    return (target: Observable<any>, key: string, descriptor: any) => {
      const originalMethod = descriptor.value;
      descriptor.value = function (...args: any[]) {
        if (!mockDecoratorEnabled || mockConfig.skip === true) {
          return originalMethod.apply(this, args);
        } else {
          httpClient = injector.get(HttpClient);
          switch (mockConfig.response.kind) {
            case 'file': {
              switch (mockConfig.response.fileType) {
                case 'png':
                case 'jpg':
                  return httpClient.get('https://picsum.photos/200.' + mockConfig.response.fileType, {responseType: 'blob'});
                case 'pdf':
                  break;
              }
            }
              break;
            case 'customObject':
              return of(mockConfig.response.payload);
            case 'jsonFile': {
              const file = `${FIXTURES_BASE_PATH}/${mockConfig.response.fileName}.json`;
              return httpClient.get(file).pipe(
                delay(DELAY_TIME_MS),
                map((fileContent) => {
                  const jsonFileMock = mockConfig.response as jsonFile;
                  if (jsonFileMock.overrides) {
                    return jsonFileMock.overrides(fileContent);
                  }
                  return fileContent;
                })
              );
            }
            case 'runtimeFaker': {
              let skipCache = true;
              const overrides = mockConfig.response.overrides;
              if (mockConfig.response.skipCache !== null && mockConfig.response.skipCache !== undefined) {
                skipCache = mockConfig.response.skipCache;
              }
              return httpClient.post(`http://localhost:8089/generate?skipCache=${skipCache}`,
                {filePath: mockConfig.response.filePath}
              ).pipe(
                map(t => {
                  return {
                    ...t,
                    ...overrides
                  };
                })
              );
            }
            case 'httpOk200':
              return httpClient.get('https://httpstat.us/200');
            case 'httpAccepted202':
              return httpClient.get('https://httpstat.us/202');
            case 'httpSuccess204':
              return httpClient.get('https://httpstat.us/204');
            case 'httpBadRequest400':
              return httpClient.get('https://httpstat.us/400');
            case 'httpLocked423':
              return httpClient.get('https://httpstat.us/423');
            case 'httpBadGateway502':
              return httpClient.get('https://httpstat.us/502');
          }
        }
      };
      return descriptor;
    };
  })();
};

export const setInjector = (i: Injector) => {
  injector = i;
};
